import { render, staticRenderFns } from "./RecentInfiniteListQuoted.vue?vue&type=template&id=7c98b163&scoped=true&lang=pug&"
import script from "./RecentInfiniteListQuoted.vue?vue&type=script&lang=js&"
export * from "./RecentInfiniteListQuoted.vue?vue&type=script&lang=js&"
import style0 from "./RecentInfiniteListQuoted.vue?vue&type=style&index=0&id=7c98b163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98b163",
  null
  
)

export default component.exports